import React, { FC, useState } from 'react';
import { useEffect } from 'react';
import { getDefaultCulture } from './utilities/languageUtilities';

interface Props {
  color?: string;
}

const LanguageSelect: FC<Props> = ({ color }: Props) => {
  const [language, setLanguage] = useState('fr');
  const frenchURL = new URLSearchParams(window.location.search);
  frenchURL.set('lang', 'fr');
  const englishURL = new URLSearchParams(window.location.search);
  englishURL.set('lang', 'en');

  useEffect(() => {
    if (window.location.search.includes('fr')) {
      setLanguage('fr');
    }
    if (window.location.search.includes('en')) {
      setLanguage('en');
    }
  }, [window.location.search]);

  useEffect(() => {
    const cultureLanguage = getDefaultCulture();
    if (cultureLanguage) {
      setLanguage(cultureLanguage);
    }
  }, []);

  return (
    <div className="language-select">
      {language && language == 'fr' && (
        <a style={{ color: color }} id="english-select" href={`${window.location.pathname}?${englishURL.toString()}`}>
          <span className="d-block d-lg-none">EN</span>
          <span className="d-none d-lg-block">English</span>
        </a>
      )}
      {language && language == 'en' && (
        <a style={{ color: color }} id="french-select" href={`${window.location.pathname}?${frenchURL.toString()}`}>
          <span className="d-block d-lg-none">FR</span>
          <span className="d-none d-lg-block">Français</span>
        </a>
      )}
    </div>
  );
};

export default LanguageSelect;
